import React, { createContext, useContext, useState, useCallback } from 'react';
import { authApi } from '../utils/api';
import { can as canPath, canSeeFinancials as roleFin } from '../utils/permissions';

const AuthContext = createContext(null);
const STORAGE_KEY = 'georges_user';
const TOKEN_KEY = 'georges_token';

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null; } catch { return null; }
  });

  const login = useCallback(async (identifiant, password) => {
    const { data } = await authApi.login(identifiant, password);
    const { token, ...userInfo } = data;
    if (token) localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(userInfo));
    setUser(userInfo);
    return userInfo;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  }, []);

  // Mot de passe provisoire remplacé : on lève l'obligation de changement.
  const mdpChange = useCallback(() => {
    setUser(u => {
      const next = { ...u, doit_changer_mdp: 0 };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const can = useCallback((path) => (user ? canPath(user.role, path, user) : false), [user]);
  const canSeeFinancials = user ? roleFin(user.role) : false;

  return (
    <AuthContext.Provider value={{ user, login, logout, mdpChange, can, canSeeFinancials }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
